import * as ents from '@attain-apps/entities'
import * as store from '@attain-apps/fe/web/main/lib/store'
import { TypeChecker } from '@attain-apps/type-guards'
import * as rxjs from 'rxjs'

import type { Feature } from '../feature'
import * as models from '../models'

/** TODO:  */
export const onDeleteNodeRelay = store.effects.create(
  (feature: Feature) =>
    feature.actions.deleteNode.relay((forward, action) => {
      const { chartId, id } = action

      if (models.Chart.Entry.get(chartId) === 'current') {
        return rxjs.of({
          cancellation: {
            reason: 'Deleting nodes is disabled for current chart.',
          },
        })
      }

      if (TypeChecker.isNullish(id)) {
        throw new Error('Node ID is required to delete a node')
      }

      return feature.selectors
        .getNode({ chartId, nodeId: id })
        .asObservable.pipe(
          rxjs.take(1),
          rxjs.filter(TypeChecker.isNotNullish.raw),
          rxjs.map(node => {
            const { modelId } = node
            return forward(feature.actions.deleteData, {
              input: {
                chartId,
                modelId,
                recordId: ents.core.display.tree.Node.Id.get(node),
              },
              output: () => ({ chartId, id }),
            })
          }),
        )
    }).asObservable,
)
